import React from 'react';
import { Card, CardContent, CardHeader, CardTitle, CardDescription } from "../ui/card";
import { Button } from "../ui/button";
import { Truck } from "lucide-react";
import { signOut } from 'firebase/auth';
import { auth } from '../../firebase/firebaseConfig';

function PreparingForShipping({ email }) {
  const handleSignOut = async () => {
    try {
      await signOut(auth);
    } catch (error) {
      console.error('Error signing out:', error);
    }
  };

  return (
    <div className="min-h-screen bg-gray-50 p-4 flex items-center justify-center">
      <Card className="w-full max-w-md">
        <CardHeader className="text-center">
          <div className="flex justify-center mb-4">
            <div className="w-16 h-16 bg-yellow-100 rounded-full flex items-center justify-center">
              <Truck className="h-8 w-8 text-yellow-600" />
            </div>
          </div>
          <CardTitle className="text-2xl">Your Hearth is About to Ship!</CardTitle>
          <CardDescription className="text-base space-y-3 mt-4 text-left">
            <p>Great news! Your Hearth is being prepared for shipment.</p>
            <p>Your destination address can no longer be updated or changed at this time.</p>
            <p>You will receive an email notification when your Hearth(s) ship with tracking information.</p>
            <p>Once you receive your Hearth(s), sign back in here to complete setup.</p>
            <p>
              If you have any questions, please contact us at{' '}
              <a
                href="mailto:hq@higlo.co"
                className="font-medium text-gray-900 hover:underline"
              >
                hq@higlo.co
              </a>
            </p>
          </CardDescription>
        </CardHeader>
        <CardContent className="space-y-4">
          {email && (
            <p className="text-sm text-center text-muted-foreground">
              Signed in as {email}
            </p>
          )}
          <div className="flex justify-center">
            <Button
              onClick={handleSignOut}
              variant="outline"
              className="w-full max-w-xs"
            >
              Sign Out
            </Button>
          </div>
        </CardContent>
      </Card>
    </div>
  );
}

export default PreparingForShipping;
